export default __webpack_public_path__ + "static/media/expedido.3cff4177.svg";